import { Link } from "react-router-dom";
import { Newspaper } from "lucide-react";

const SOCIALS = [
  { name: "TikTok", href: "#", label: "TikTok (próximamente)" },
  { name: "Instagram", href: "#", label: "Instagram (próximamente)" },
  { name: "LinkedIn", href: "#", label: "LinkedIn (próximamente)" },
];

const PAGES = [
  { label: "Quiénes somos", to: "/quienes-somos" },
  { label: "Compromiso de calidad", to: "/compromiso-calidad" },
  { label: "Política de cookies", to: "/politica-cookies" },
];

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="mt-16 border-t border-border bg-foreground text-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
        <div className="flex items-center gap-3 mb-10">
          <div className="w-8 h-8 bg-primary flex items-center justify-center">
            <Newspaper className="w-4 h-4 text-white" />
          </div>
          <span className="font-heading font-black tracking-tight">NEWS DIGEST</span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-10">
          {/* Left: value-prop pages */}
          <div data-testid="footer-pages">
            <p className="text-[11px] uppercase tracking-widest text-background/50 font-semibold mb-4">
              Sobre nosotros
            </p>
            <ul className="space-y-3">
              {PAGES.map((p) => (
                <li key={p.to}>
                  <Link
                    to={p.to}
                    data-testid={`footer-link-${p.to.slice(1)}`}
                    className="text-sm text-background/80 hover:text-background transition-colors"
                  >
                    {p.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Right: socials (provisional) */}
          <div data-testid="footer-socials" className="sm:text-right">
            <p className="text-[11px] uppercase tracking-widest text-background/50 font-semibold mb-4">
              Síguenos
            </p>
            <ul className="space-y-3">
              {SOCIALS.map((s) => (
                <li key={s.name}>
                  <a
                    href={s.href}
                    aria-label={s.label}
                    data-testid={`footer-social-${s.name.toLowerCase()}`}
                    className="text-sm text-background/80 hover:text-background transition-colors"
                  >
                    {s.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <p className="mt-10 pt-6 border-t border-background/10 text-xs text-background/40">
          © {new Date().getFullYear()} News Digest. Todos los derechos reservados.
        </p>
      </div>
    </footer>
  );
};
